(ns hypnos.consumer.panels.portrait
  "Panel to (just) upload a portrait."
  (:require [hypnos.consumer.panels.portrait.done :as done]
            [hypnos.consumer.panels.portrait.not-found :as not-found]
            [hypnos.consumer.panels.portrait.portrait :as portrait]
            [medley.core :as mc]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:private true} defaults
  {;; workflow
   :step       :portrait
   :step-count 0
   ;; consult
   :consult    {:consult/key   {:value    nil
                                :dirty?   false
                                :touched? false}
                ;; image
                :consult/image {:value    nil
                                :dirty?   false
                                :touched? false}}})

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- nav-fn
  [state current-step direction]
  (condp = current-step
    :portrait (when (= direction :next)
                (swap! state assoc
                       :step :done))
    :done     (swap! state assoc :step :done)
    (swap! state assoc :step nil)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The portrait panel"
  [{:keys [consult-key]}]
  (rf/dispatch-sync [:consumer/set-consult {:data {:consult {:key consult-key}}}])
  (let [state (reagent/atom (mc/deep-merge defaults
                                           {:consult {:consult/key {:value consult-key}}}))]
    (fn [{:keys [_consult-key]}]
      [:div.card
       [:div.card-header
        [:p.card-header-title]]
       (condp = (:step @state)
         :portrait             [portrait/step state nav-fn]
         :done                 [done/step]
         [not-found/step])])))
